import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

if (document.getElementsByClassName('logos-section__slider')[0]) {
  const logosSlidersArr = document.querySelectorAll('.logos-section__slider');
  logosSlidersArr.forEach((sliderEl, sliderIdx) => {
    /*const slides = sliderEl.querySelectorAll('.swiper-slide');
    let loop = false;
    let loopedSlides = false;

    if (slides.length >= 4) {
      loop = true;
      loopedSlides = slides.length * 4;
    }*/

    const logosSwiper = new Swiper(sliderEl, {
      modules: [Autoplay, Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      threshold: 10,
      /*loop: loop,
      loopedSlides: loopedSlides,*/
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      /*navigation: {
        prevEl: sliderEl.querySelector('.slider-buttons .slider-btn.prev'),
        nextEl: sliderEl.querySelector('.slider-buttons .slider-btn.next'),
      },*/
      breakpoints: {
        551: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        651: {
          spaceBetween: 16,
          slidesPerView: 3,
        },
        901: {
          spaceBetween: 12,
          slidesPerView: 4,
        },
        1025: {
          spaceBetween: 16,
          slidesPerView: 4,
        },
        1200: {
          spaceBetween: 20,
          slidesPerView: 4,
        },
      },
    });

    swiperObserver(logosSwiper);
  });
}
